import React from 'react';

import { RadioButton } from '@rbilabs/components-library/build/components/radio-button';
import { useIntl } from 'react-intl';

import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

import { DeleteDeliveryAddressButton } from '../delete-delivery-address-button';

import { AddressContainer, RadioButtonContainer } from './styled';
import { IDeliveryAddressItemProps } from './types';

export const DeliveryAddressItem: React.FC<IDeliveryAddressItemProps> = ({
  addressLocation,
  selected,
  onSelect,
}) => {
  const { formatMessage } = useIntl();

  const {
    address: { addressLine1, addressLine2, city, state, zip, streetNumber, route, location: alias },
  } = addressLocation;

  //TO-DO: Remove this flag after the issue is fixed, Tech Debt: https://rbictg.atlassian.net/browse/TRX-1588
  const validateDeliveryAddressInfo = useFlag(LaunchDarklyFlag.VALIDATE_DELIVERY_ADDRESS_INFO);

  const hideAddress =
    validateDeliveryAddressInfo &&
    (!addressLine1 || !city || !state || !streetNumber || !route || !zip);
  if (hideAddress) {
    return null;
  }

  const deliveryHeader = (
    <div data-private data-dd-privacy="mask" data-testid="address-lines">
      {alias}
      <div>{addressLine1}</div>
      <div>{addressLine2 && formatMessage({ id: 'unitNumber' }, { unitNumber: addressLine2 })}</div>
    </div>
  );

  const deliveryLabel = (
    <div data-private data-dd-privacy="mask" data-testid="address-extra-info">
      {city}, {state} {zip}
    </div>
  );

  return (
    <>
      <AddressContainer data-testid="delivery-address-item">
        <RadioButtonContainer>
          <RadioButton
            checked={selected}
            onChange={onSelect}
            labelHeader={deliveryHeader}
            label={deliveryLabel}
          />
        </RadioButtonContainer>

        <DeleteDeliveryAddressButton addressLocation={addressLocation} />
      </AddressContainer>
    </>
  );
};
